export const pages = {
	'boltHome': { id: 'boltHome', page: 'home', getter: () => import(/* webpackChunkName: 'boltHome' */ 'components/bolt/home/home') },
	'boltGallery': { id: 'boltGallery', page: 'gallery', getter: () => import(/* webpackChunkName: 'boltGallery' */ 'components/bolt/gallery/gallery') }
};
import synopsis from 'components/bolt/synopsis/synopsis';
import gallery from 'components/bolt/gallery/gallery';
export const sections = [
	{ id: 'boltSynopsis', isPreloaded: true, component: synopsis },
	{ id: 'boltGallery', isPreloaded: true, component: gallery },
	{ id: 'boltWatchMore', getter: () => import(/* webpackChunkName: "boltWatchMore" */ 'components/bolt/watchMore/watchMore'), component: 'watchMore' }
];
export const sectionsWithParent = [

];
import SidePanelLoader from 'components/bolt/sidePanelLoader/sidePanelLoader';
export { SidePanelLoader };
import VideoOverlayLoader from 'components/bolt/videoOverlayLoader/videoOverlayLoader';
export { VideoOverlayLoader };
